import { useRemoteResource } from "hooks/useRemoteResource";
import withRouter from "hoc/withRouter";
import { Button, CircularProgress } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import AppTable from "components/AppTable/AppTable";
import broadcastService from "services/admin/broadcastService";
import AppAdminTable from "components/AppAdminTable/AppAdminTable";
import { toast } from "react-toastify";

const BroadcastList = () => {
    const columnConfig = [
        {
            key: "id",
            label: "ID"
        },
        {
            key: "name",
            label: "Название"
        },
        {
            key: "createdAt",
            label: "Дата создания"
        },
        {
            key: "updatedAt",
            label: "Дата обновления"
        },
        {
            key: "send",
            label: "Отправить",
            render: (item) => {
                return <Button onClick={() => sendBroadcast(item.id)}>Отправить рассылку</Button>
            }
        },
        // Поставить на паузу
        {
            key: "pause",
            label: "Поставить на паузу",
            render: (item) => {
                return <Button onClick={() => pauseBroadcast(item.id)}>Поставить на паузу</Button>
            }
        },
        // Возобновить
        {
            key: "resume",
            label: "Возобновить",
            render: (item) => {
                return <Button onClick={() => resumeBroadcast(item.id)}>Возобновить</Button>
            }
        },
        // Удалить
        {
            key: "stop",
            label: "Остановить",
            render: (item) => {
                return <Button onClick={() => stopBroadcast(item.id)}>Остановить</Button>
            }
        }
    ]

    const [data, loadData, loading, error] = useRemoteResource(broadcastService.getAll, "");

    const sendBroadcast = async (id) => {
        console.log(id);
        try {
            await broadcastService.send(id);
            toast.success("Рассылка отправлена всем пользователям");
        } catch (error) {
            console.error(error);
            toast.error("Произошла ошибка при отправке рассылки");
        }
    }

    const pauseBroadcast = async (id) => {
        console.log(id);
        try {
            await broadcastService.pause(id);
            toast.success("Рассылка поставлена на паузу");
        } catch (error) {
            console.error(error);
            toast.error("Произошла ошибка при постановке рассылки на паузу");
        }
    }

    const resumeBroadcast = async (id) => {
        console.log(id);
        try {
            await broadcastService.resume(id);
            toast.success("Рассылка возобновлена");
        } catch (error) {
            console.error(error);
            toast.error("Произошла ошибка при возобновлении рассылки");
        }
    }

    const stopBroadcast = async (id) => {
        console.log(id);
        try {
            await broadcastService.stop(id);
            toast.success("Рассылка остановлена");
        } catch (error) {
            console.error(error);
            toast.error("Произошла ошибка при остановке рассылки");
        }
    }

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (loading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }
        if (data.length === 0) {
            return <div>Рассылки отсутсвуют. Чтобы добавить рассылку пожалуйста, нажмите на кнопку "Добавить" сверху</div>
        }
        if (data.length > 0) {
            return <AppAdminTable data={data} columnConfig={columnConfig} />
        }
    }
    return (
        <ListPage pageTitle="Список рассылок">
            <div className="m-t-32">
                {buildContent()}
            </div>
        </ListPage>

    );
};

export default withRouter(BroadcastList);
